module.exports = __webpack_public_path__ + "img/2.272aff41.jpg";